import { action, observable, makeObservable, toJS } from "mobx";

import ym from "react-yandex-metrika";
import { _getByUrl, _postByUrl, _putByUrl, _deleteByUrl, _initServiceAfterAuth } from "./service";
import { delay, getWhatId, parseAbQuery } from "../helpers/utils";

const { VITE_WHAT_ID } = import.meta.env;

const DELAYLOADER = 100;

class MainStore {
    mainStore = {
        initialApp: "notCompleted", // loading, complete
        preload_data: false,
        loader: false,
        numberOfPoints: false,
        notification: false,
        modal: false,
        horseModal: false,
        captcha: false,
        capToken: "qwerty",
        init: false,
        locationData: false,
        userLocation: false,
        offersList: false,
        abTest: {}, // Инициализируем пустым объектом
        isNotFound: false,
        isStart: false,
        listLoader: false,
        isVisible: false,
        isCoverRoot: true, //удалить как в ios26 пофиксят прозрачность полосок браузера
        horse_session: false,
        settingLego: {
            bgColor: "default",
            ctaColor: "default",
            queueDuration: 5,
            queueRandomness: true,
            isPartnerHeaderVariant: true,
        },
    };

    constructor(props) {
        makeObservable(this, {
            mainStore: observable,
            setMainStore: action,
        });
    }

    initStore = async () => {
        console.log("init store");

        // проверяем на лишние параметры в урл, если есть останавливаем инит и выводим страницу 404
        const exludeParams = ["documents"];
        const params = window?.location?.pathname?.split("/");
        const firstParam = params?.[1] || false;
        const parsedAB = parseAbQuery();

        // Проверяем, является ли первый параметр фич-веткой (DEV-{number})
        const isFeatureBranch = firstParam && /^DEV-\d+$/.test(firstParam);

        if (isFeatureBranch) {
            console.log("🔧 Фич-ветка обнаружена:", firstParam);
        }

        const isNotFound = firstParam ? !exludeParams.includes(firstParam) && !isFeatureBranch : false; // если первого параметра нет в исключениях и это не фич-ветка

        if (isNotFound) {
            this.setMainStore("isNotFound", true);
            return;
        }
        // проверяем на лишние параметры в урл, если есть останавливаем инит и выводим страницу 404

        // не делаем запрос на инит, если есть в исключениях при которых не нужны дальнейшие запросы
        const exludeInit = ["documents"];
        if (firstParam && exludeInit.includes(firstParam)) {
            console.log("📄 Документы - пропускаем инициализацию");
            this.setMainStore("initialApp", "complete");
            return;
        }

        const searchParams = new URLSearchParams(window?.location?.search);
        const offerId = searchParams.get("id"); // айдишка офера в ссылке
        const em_hash = searchParams.get("em_hash");
        let utmParams = {};
        const utmString = new URLSearchParams();

        for (const [key, value] of searchParams) {
            if (key.startsWith("utm_")) {
                if (value.length) {
                    utmParams[key] = value;
                    utmString.append(key, value);
                } else {
                    utmParams = {};
                }
            }
        }

        const _ym_uid =
            document.cookie
                .split("; ")
                .find((row) => row.startsWith("_ym_uid="))
                ?.split("=")[1] || "";

        let gender = "";
        let age = "";
        let utmCampaignData = false;
        let utmCampaign = false;

        console.log("utmParams", utmParams);

        if (Object.keys(utmParams).length) {
            utmCampaign = utmParams?.utm_campaign?.split("|");
            utmCampaignData = utmCampaign && utmCampaign[0] ? utmCampaign[0].split("_") : "";
            gender = utmCampaignData[0] === "Male" || utmCampaignData[0] === "Fem" || utmCampaignData[0] === "Female" ? utmCampaignData[0] : "";
            age = utmCampaignData && utmCampaignData[1]?.includes("-") && /^\d+-\d+$/.test(utmCampaignData[1]) ? utmCampaignData[1] : "";
        }

        const now = new Date();

        function getDeviceType() {
            const userAgent = navigator.userAgent;

            if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())) {
                if (/ipad|android(?!.*mobile)|tablet/i.test(userAgent)) {
                    return "tablet";
                }
                return "mobile";
            }

            return "desktop";
        }

        const weekday = now.toLocaleDateString("en-US", { weekday: "long" });
        const ua = navigator.userAgent;
        let platform = "";

        if (/iPad|iPhone|iPod/.test(ua)) {
            platform = "iOS";
        } else if (/Mac/.test(ua)) {
            platform = "macOS";
        } else if (/Win/.test(ua)) {
            platform = "Windows";
        } else if (/Android/.test(ua)) {
            platform = "Android";
        } else if (/Linux/.test(ua)) {
            platform = "Linux";
        }

        const dataUser = {
            ym_uid: _ym_uid,
            from_partner: Object.keys(utmParams).length && utmParams.utm_source ? utmParams.utm_source : "",
            transition_type: utmCampaign ? utmCampaign[utmCampaign.length - 1].trim() : "",
            device_platform: platform,
            device_type: getDeviceType(),
            device_screen: `${window.innerWidth}:${window.innerHeight}`,
            week_day: weekday,
            gender: gender || "",
            age: age || "",
            utm_in: utmString ? utmString.toString() : "",
            // platform: navigator.userAgentData.platform,
            // typeDevice: getDeviceType(),
            // screen: `${window.innerWidth}:${window.innerHeight}`,
            // partner: Object.keys(utmParams).length ? utmParams.utm_source : '',
            // typeTransition: utmCampaign ? utmCampaign[utmCampaign.length - 1] : null,
            // timeOfDay: timeOfDay,
            // weekDay: weekday,
            // gender: gender || "",
            // age: age || "",
        };

        console.log("~ MainStore ~ dataUser:", dataUser);
        console.log("🚀 Начинаем инициализацию приложения...");

        const init = await this.postByUrl("/app_rispromo_init/initial", { _ym_uid: _ym_uid, em_hash: em_hash, u_data: dataUser, ...parsedAB }, true, false, "init", false);
        if (init && init.success && init.data) {
            console.log("✅ Инициализация успешна:", init);
            this.setMainStore("init", init);
            this.setMainStore("initialApp", "loading");

            const cdValue = init?.data?._w_d?._cd;
            const cdPrefix = typeof cdValue === "string" ? cdValue.split("_")[0] : "";
            const cdConfig = init?.data?._w_d?.config;
            const wdCd = init?.data?._w_d?._cd;
            const getPromoUrl = init?.data?._p_g_p ? init?.data?._p_g_p : false;


            const MODAL_MAP = {
                ai: "ai",
                face: "face",
                koleso: "koleso",
                categoria: "ai",
            };
            const modalType = MODAL_MAP[cdPrefix] ?? "ava-wheel";

            this.setMainStore("settingLego", cdConfig);
            this.setMainStore("codeTypeMetrika", wdCd);
            this.setMainStore("getPromoUrl", getPromoUrl);


            if (!offerId && !em_hash) {
                const preload_app = await this.getByUrl("/app_rispromo_init/preload_app", "", false, "", false);
                if (preload_app.success) {
                    console.log("🚀 preload_app OK");
                    this.setMainStore("preload_data", preload_app.data);
                }

                this.setMainStore("initialApp", "complete");
                this.setMainStore("isStart", true);
                this.setMainStore("modal", { type: modalType }); // включаем первую модалку колеса если нет offerId
                await delay(0);
            } else {
                this.setMainStore("isCoverRoot", false); //удалить как в ios26 пофиксят прозрачность полосок браузера
                this.setMainStore("isVisible", true);

                if (init?.data?._ab_m?.["dev_1747"]?._v === "dev_1747_v3" || offerId) {
                    this.setMainStore("horseModal", false);
                } else {
                    this.setMainStore("horseModal", true);
                }

                const step = localStorage.getItem("horseTasks") ? parseInt(localStorage.getItem("horseTasks")) : 0;
                const pointsMap = { 3: 5, 4: 6, 5: 7 };
                this.setMainStore("numberOfPoints", pointsMap[step] ?? step);

                if (step < 2 && init?.data?._ab_m?.["dev_1747"]?._v) {
                    const abTestMetika = this.getMainStore("abTestMetika");
                    const metrikaKey = abTestMetika || "ris_promo";
                    ym("reachGoal", `second_task_completed`, { reachGoal: { [metrikaKey]: { ["second_task_completed"]: { null: { null: { null: { null: { null: what_id } } } } } } } });
                }
            }

            this.setMainStore("horse_session", init.data._h_session);

            if (init.data._uu) {
                localStorage.setItem("_uuid_rispromo", init.data._uu);
            }

            let siteTheme = false;
            if (init.data && init.data._ab_m && Object.values(init.data._ab_m).length) {
                let dataTest = {};
                let dataNameTest = false;
                for (let prop in init.data._ab_m) {
                    if (init.data._ab_m[prop] && init.data._ab_m[prop]._d) {
                        dataTest = { ...dataTest, ...init.data._ab_m[prop]._d };
                        dataNameTest = init.data._ab_m[prop]._d.metrikaKey;
                        siteTheme = init.data._ab_m[prop]._d.siteTheme;
                    }
                }

                this.setMainStore(`test`, dataTest);
                this.setMainStore("abTestMetika", dataNameTest);
            }

            // установка выбранной темы или дефолтной
            const theme = siteTheme ? siteTheme : init?.data?._p_t || "default";
            this.setMainStore(`theme`, theme);
            document.documentElement.dataset.theme = theme;
            // установка выбранной темы или дефолтной

            // запись и обновление в headers токена
            const token = init?.data._t || "";
            localStorage.setItem("token", token);
            _initServiceAfterAuth(token);

            if (!localStorage.getItem("horseTasks")) {
                localStorage.setItem("horseTasks", 0);
            }
            // запись и обновление в headers токена

            // получение офферов ддя дальнейшей отрисовки колеса фортуны и списка офферов

            await this.getByUrl("/app_rispromo_user/user_locations", "", false, "userLocation", "", false); // запрос локации пользователя
            const offersList = await this.getByUrl("/app_rispromo/offers_list", parsedAB, false, "", false);
            let apdated = null;
            if (offersList && offersList.success && offersList.data) {
                const offers = offersList.data || null;
                if (offers?.promo) {
                    apdated = this.apdateOffers(offers);
                    this.setMainStore("offersList", apdated);
                }

                // AB_1662
                if (init?.data?._ab_m?.["dev_1662_28.11.2025"]?._d?.colorHeader === "v2") {
                    const categories = [];
                    const offersByCategory = new Map();
                    const seen = new Set();

                    offersByCategory.set("all", apdated);

                    offers.offers.forEach((offer) => {
                        offer.vendorcategories.forEach((cat) => {
                            const { alias } = cat;

                            if (!seen.has(alias)) {
                                seen.add(alias);
                                categories.push(cat);
                                offersByCategory.set(alias, []);
                            }

                            offersByCategory.get(alias).push(offer);
                        });
                    });

                    this.setMainStore("offerCategories", categories);
                    this.setMainStore("offersByCategory", offersByCategory);
                }
                // AB_1662

                // Безопасная проверка _ab_m
                if (offersList.data._ab_m) {
                    this.setMainStore("abTest", offersList.data._ab_m);
                } else {
                    // Устанавливаем пустой объект, если _ab_m отсутствует
                    this.setMainStore("abTest", {});
                }
            }
            // получение офферов ддя дальнейшей отрисовки колеса фортуны и списка офферов

            this.setMainStore("initialApp", "complete"); // init done

            const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

            const urlParams = new URLSearchParams(window.location.search);
            const disableMetrika = urlParams.has("noym");

            if (!disableMetrika) {
                try {
                    const abTestMetika = this.getMainStore("abTestMetika");
                    const metrikaKey = abTestMetika || "ris_promo";
                    ym("reachGoal", `entry`, { reachGoal: { [metrikaKey]: { ["entry"]: { null: { null: { null: { null: { [wdCd]: what_id } } } } } } } });

                    function checkReachGoalReady(maxAttempts = 10, interval = 500) {
                        return new Promise((resolve, reject) => {
                            let attempts = 0;

                            const checkInterval = setInterval(() => {
                                attempts++;

                                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                                    clearInterval(checkInterval);
                                    resolve(true);
                                } else if (attempts >= maxAttempts) {
                                    clearInterval(checkInterval);
                                    reject(new Error("reachgoal_ch не загружена"));
                                }
                            }, interval);
                        });
                    }

                    // Использование
                    checkReachGoalReady()
                        .then(() => {
                            window.risMetrika.reachgoal_ch({
                                event: "entry",
                                siteId: what_id,
                                session_uuid: localStorage.getItem("_r_p_s"),
                                widget_code: wdCd ? wdCd : "",
                            });
                        })
                        .catch((error) => {
                            console.error("Не удалось загрузить reachgoal_ch:", error);
                        });
                } catch (error) {
                    console.warn("Ошибка при отправке метрики:", error);
                }
            }

            const region = await this.getByUrl("/app_rispromo_supply/locations", "", false, "locationData", false); // запускаем в фоне пока крутятся модалки остальные запросы и формирование списка офферов

            if (region && region.success && region.data && Array.isArray(region.data)) {
                const city = [];
                const metro = [];

                region.data.forEach((el) => {
                    if (el && el.cities && Array.isArray(el.cities) && el.cities.length) {
                        if (el.name === "Москва" || el.name === "Санкт-Петербург") {
                            city.push([{ ...el.cities[0], metro: el.metro }]);
                        } else {
                            city.push(el.cities);
                        }

                        el.cities.forEach((elMetro) => {
                            if (elMetro && elMetro.metro && Array.isArray(elMetro.metro) && elMetro.metro.length) {
                                metro.push(elMetro.metro);
                            }
                        });
                    }
                    if (el && el.metro && Array.isArray(el.metro) && el.metro.length) {
                        metro.push(el.metro);
                        // const obj = { ...el, cities: [], city: el.name_with_type };
                        // city.push({ ...obj, metro: el.metro });
                    }
                });

                this.setMainStore("citiesData", city.flat());
                this.setMainStore("metroData", metro.flat());
            }

            if (window.risMetrika && window.risMetrika.init) {
                window.risMetrika.init({
                    counter: "g9Swn4hE5Y",
                    domain: window.location.hostname === "ris.promo" ? "apity.ris.promo" : "apity.ris.promo",
                    rps: localStorage.getItem("_r_p_s"),
                });
            }
        }
    };

    getByUrl = async (url, params = "", reqHeaders = false, key = "", loader = true, change_url = false) => {
        loader && this.setMainStore("loader", true);
        const service = await _getByUrl(url, params, reqHeaders, change_url);
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: service?.msg || service?.data?.msg || "Что-то пошло не так" });
        } else if (key) {
            this.setMainStore(key, service.data);
        }

        return service;
    };

    postByUrl = async (url, params = "", cda, reqHeaders = false, key = "", loader = true) => {
        loader && this.setMainStore("loader", true);
        const service = await _postByUrl(url, params, cda);
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: service?.msg || service?.data?.msg });
        } else if (key) {
            console.log(key, service.data);

            this.setMainStore(key, service.data);
        }

        return service;
    };

    putByUrl = async (url, params = "", reqHeaders = false, key = "", loader = true) => {
        loader && this.setMainStore("loader", true);
        const service = await _putByUrl(url, params);
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: service?.msg || service?.data?.msg });
        } else if (key) {
            this.setMainStore(key, service.data);
        }

        return service;
    };

    deleteByUrl = async (url, params = "", reqHeaders = false, key = "", loader = true) => {
        loader && this.setMainStore("loader", true);
        const service = await _deleteByUrl(url);
        loader && (await delay(DELAYLOADER));
        loader && this.setMainStore("loader", false);

        if (service && !service.success) {
            this.checkErrorCode(service);
            this.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: service?.msg || service?.data?.msg });
        } else if (key) {
            this.setMainStore(key, service.data);
        }

        return service;
    };

    getMainStore = (key) => {
        if (typeof this.mainStore[key] === "undefined") {
            return false;
        } else {
            return toJS(this.mainStore[key]);
        }
    };

    setMainStore = (key, value) => {
        this.mainStore[key] = value;
    };

    checkErrorCode = (service) => {
        const code = service?.status || 0;
        console.log("checkErrorCode", code);

        switch (code) {
            case 429:
                console.log("is captcha");
                // this.setMainStore("captcha", true);
                break;

            default:
                break;
        }
    };

    apdateOffers = (obj = {}) => {
        return obj.promo.reduce((acc, row) => {
            for (let i = 0; i < acc.offers.length; i++) {
                const el = acc.offers[i];
                if (el._id == row.offerId) {
                    el.promoCode = row.code;
                    break;
                }
            }
            return acc;
        }, obj);
    };

    addPromoToOffer = (obj = {}) => {
        const offersList = this.getMainStore("offersList");
        offersList.promo.push(obj);
        const adapted = this.apdateOffers(offersList);
        this.setMainStore("offersList", adapted);
        return adapted;
    };
}

export default new MainStore();
